var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneStand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.4504 22.832L8.88038 43.1395C7.9441 44.2206 7.45218 45.6162 7.50367 47.0454C7.55516 48.4746 8.14624 49.8312 9.15788 50.842C10.1687 51.8537 11.5253 52.4447 12.9545 52.4962C14.3837 52.5477 15.7794 52.0558 16.8604 51.1195L37.1679 33.5495L26.4504 22.832Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3851 39.4848C22.0145 39.4844 21.6523 39.3743 21.3442 39.1683C21.0362 38.9622 20.7961 38.6695 20.6544 38.3271C20.5126 37.9847 20.4754 37.6079 20.5477 37.2444C20.6199 36.8809 20.7982 36.547 21.0601 36.2848L23.5426 33.8023C23.8984 33.4694 24.3697 33.2879 24.8569 33.2962C25.3441 33.3044 25.809 33.5017 26.1534 33.8464C26.4977 34.1911 26.6946 34.6562 26.7024 35.1434C26.7102 35.6306 26.5283 36.1017 26.1951 36.4573L23.7101 38.9373C23.5362 39.1113 23.3296 39.2493 23.1022 39.3432C22.8748 39.4372 22.6311 39.4853 22.3851 39.4848Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5428 26.8897L33.1128 10.4597C34.1788 9.46153 35.4353 8.68868 36.8069 8.18733C38.1786 7.68599 39.6372 7.46644 41.0957 7.54182C42.5541 7.61721 43.9824 7.98598 45.2951 8.62607C46.6077 9.26617 47.7778 10.1644 48.7353 11.2672C49.838 12.2246 50.7362 13.3947 51.3763 14.7073C52.0164 16.02 52.3852 17.4483 52.4606 18.9067C52.536 20.3652 52.3164 21.8238 51.8151 23.1955C51.3137 24.5671 50.5409 25.8236 49.5428 26.8897ZM29.8303 13.5997C28.4971 14.7038 27.4802 16.1414 26.8829 17.7662C26.2857 19.391 26.1295 21.1449 26.4303 22.8497L37.1478 33.5672C38.8525 33.8679 40.6065 33.7117 42.2312 33.1145C43.856 32.5173 45.2936 31.5003 46.3978 30.1672L46.9578 29.6072L30.3903 13.0397L29.8303 13.5997Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.5392 26.889L33.1092 10.459C32.7917 10.7265 32.4617 10.959 32.1592 11.2665L30.3867 13.039L46.9592 29.6115L48.7317 27.839C49.0367 27.5365 49.2717 27.2065 49.5392 26.889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneStand);
export default __webpack_public_path__ + "static/media/microphoneStand.963156024d9bc0e12fcaa455492766a9.svg";
export { ForwardRef as ReactComponent };